<template>
    <div id="refuseHandle" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>检修管理</el-breadcrumb-item>
                <el-breadcrumb-item>婉拒处理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">检修单号:</div>
            <el-input
                style="width: 180px"
                class="search-item"
                size="small"
                v-model.trim="searchData.RCode"
                placeholder="请输入检修单号"
            ></el-input>
            <div class="search-name">汽修厂:</div>
            <el-input
                style="width: 180px"
                class="search-item"
                size="small"
                v-model.trim="searchData.EntpName"
                placeholder="请输入汽修厂名称"
            ></el-input>
            <div class="search-name">车主:</div>
            <el-input
                style="width: 180px"
                class="search-item"
                size="small"
                v-model.trim="searchData.ClientName"
                placeholder="请输入车主名称或手机号"
            ></el-input>
            <div class="search-name">状态:</div>
            <el-select
                size="small"
                class="search-item"
                v-model="searchData.State"
                placeholder="请选择"
            >
                <el-option
                    v-for="item in orderState"
                    :key="item.Tkey"
                    :label="item.TValue"
                    :value="item.Tkey"
                ></el-option>
            </el-select>
            <div>
                <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-search"
                    class="search-btn"
                    @click="handleSearch"
                >查询</el-button>
                <el-button
                    type="primary"
                    size="small"
                    icon="el-icon-refresh"
                    class="search-btn"
                    @click="resetSearch"
                >重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{background:'#F2F6FC'}"
                :data="recordsList"
                border=""
                style="width: 100%"
            >
                <el-table-column
                    width="190px"
                    show-overflow-tooltip
                    prop="ReservationCode"
                    label="预约号"
                ></el-table-column>
                <el-table-column show-overflow-tooltip prop="EntpName" label="汽修厂"></el-table-column>
                <el-table-column show-overflow-tooltip prop="RName" label="车主"></el-table-column>
                <el-table-column show-overflow-tooltip prop="RPhone" label="车主电话"></el-table-column>
                <el-table-column show-overflow-tooltip prop="RCarNum" label="车牌号"></el-table-column>
                <el-table-column show-overflow-tooltip prop="BrandSeries" label="车型"></el-table-column>
                <el-table-column show-overflow-tooltip prop="ReservationTime" label="预约时间"></el-table-column>
                <el-table-column show-overflow-tooltip prop="RefuseReason" label="拒绝原因"></el-table-column>
                <el-table-column show-overflow-tooltip label="状态">
                    <template slot-scope="scope">{{ scope.row.IsDeal==0?"未受理":"已受理"}}</template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="scope.row.IsDeal===0 && permission.受理"
                            @click="handleRefuse(scope.row,scope.$index)"
                        >受理</el-button>
                        <el-button
                            type="text"
                            size="small"
                             v-if="scope.row.IsDeal===1"
                            @click="handleCheck(scope.row)"
                        >查看受理结果</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchData.totalCount"
            ></el-pagination>
        </div>
        <el-dialog title="处理结果" :close-on-click-modal="false" :visible.sync="dialogFormVisible">
            <div class="dialog-content">
                <el-form
                    :model="HandleRefuseForm"
                    :rules="rules"
                    ref="HandleRefuseForm"
                    label-width="80px"
                    size="mini"
                >
                    <el-form-item label="处理结果" prop="result">
                        <el-input
                            v-model="HandleRefuseForm.result"
                            autocomplete="off"
                            type="textarea"
                        ></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('HandleRefuseForm')">取 消</el-button>
                <el-button type="primary" @click="saveHandle('HandleRefuseForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
  name: "repairRecords",
  data() {
    return {
      orderState: [
        { Tkey: -1, TValue: "不限" },
        { Tkey: 0, TValue: "未受理" },
        { Tkey: 1, TValue: "已受理" }
      ],
      searchData: {
        RCode: "",
        EntpName: "",
        ClientName: "",
        CarNum: "",
        State: -1,
        StartDate: "",
        EndDate: "",
        page: 1, // 当前页数
        limit: 10, // 每页限制条数
        totalCount: 0
      },
      recordsList: [],
      permission: {},
      dialogFormVisible: false,
      HandleRefuseForm: { rid: "", result: "", index: 0 },
      rules: {
        result: [
          { required: true, message: "请输入结果", trigger: "blur" },
          { max: 200, message: "长度超长", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.getRefuseReservationList();
    this.$util.getPermission("婉拒处理").then(res => {
      this.permission = res;
    });
  },
  methods: {
    handleSearch() {
      this.searchData.page = 1;
      this.getRefuseReservationList();
    },
    getRefuseReservationList() {
      this.axios
        .get("/RepairManagement/GetRefuseReservationList", {
          params: this.searchData
        })
        .then(result => {
          this.recordsList = result.data.data;
          this.searchData.totalCount = result.data.count;
        });
    },
    resetSearch() {
      this.searchData = {
        RCode: "",
        EntpName: "",
        ClientName: "",
        CarNum: "",
        State: -1,
        StartDate: "",
        EndDate: "",
        page: 1, // 当前页数
        limit: 10 // 每页限制条数
      };
    },
    handleSizeChange(val) {
      this.searchData.page = 1;
      this.searchData.limit = val;
      this.getRefuseReservationList();
    },
    handleCurrentChange(val) {
      this.searchData.page = val;
      this.getRefuseReservationList();
    },
    handleCheck(val) {
      this.$alert(val.DealResult, "处理结果", {
        confirmButtonText: "确定",
        callback: action => {}
      });
    },
    handleRefuse(row, index) {
      this.dialogFormVisible = true;
      this.HandleRefuseForm.rid = row.RefuseId;
      this.HandleRefuseForm.result = "";
      this.HandleRefuseForm.index = index;
    },
    saveHandle(formName) {
      let that = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          let _formData = {
            RefuseId: that.HandleRefuseForm.rid,
            Result: that.HandleRefuseForm.result
          };
          this.axios
            .post("/RepairManagement/HandleRefuseReservation", _formData)
            .then(res => {
                let result = res.data;
              if (result.errcode == 0&&result.data) {
                this.recordsList[that.HandleRefuseForm.index].IsDeal = 1;
                this.recordsList[that.HandleRefuseForm.index].DealResult =
                  that.HandleRefuseForm.result;
                this.$util.successMsg("处理成功");
                this.dialogFormVisible = false;
              } else {
                this.$util.errorMsg("处理失败");
              }
            })
            .catch(error => {
              this.$util.errorMsg("处理失败");
            });
        }
      });
    },
    //取消婉拒
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.$refs[formName].clearValidate();
      this.dialogFormVisible = false;
    }
  }
};
</script>
